import React, { useState, useEffect } from "react";
import CallLogsTable from "../components/CallLogsTable";
import CallLogForm from "../components/CallLogForm";
import FilterOptions from "../components/FilterOptions";
import API_BASE_URL from "../../../../../../Constants";
import QuickDispatcher from "../components/QuickDispatcher";

import PaginationControls from "../components/PaginationControls";

const CallLogsPage = ({ mechanics, setMechanics, setLatestDispatch }) => {
    const [callLogs, setCallLogs] = useState([]);
    const [filteredLogs, setFilteredLogs] = useState([]);
    const [filters, setFilters] = useState({ status: "", priority: "" });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingCallLog, setEditingCallLog] = useState(null);
    const [isFollowUp, setIsFollowUp] = useState(false);
    const [selectedLog, setSelectedLog] = useState(null);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const searchQuery = ""

    const [isLoading, setIsLoading] = useState(true);


    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(1);
    };


    useEffect(() => {
        fetchCallLogs(searchQuery, currentPage, rowsPerPage);
        fetchMechanics();
    }, []);


    useEffect(() => {
        fetchCallLogs(searchQuery, currentPage, rowsPerPage);
    }, [currentPage, rowsPerPage]);

    useEffect(() => {
        applyFilters();
    }, [filters, callLogs]);


    const fetchCallLogs = async (searchQuery, currentPage, rowsPerPage) => {
        try {

            setIsLoading(true);
            // Validate page and size parameters
            const validPage = isNaN(currentPage) || currentPage < 1 ? 1 : currentPage;
            const validSize = isNaN(rowsPerPage) || rowsPerPage < 1 ? 10 : rowsPerPage;

            const queryString = searchQuery ? `&q=${encodeURIComponent(searchQuery)}` : '';

            const response = await fetch(`${API_BASE_URL}/api/callcenter/calllogs/filtered-calllogs/false?&page=${validPage - 1}&size=${validSize}${queryString}`,);
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const data = await response.json();
            setCallLogs(Array.isArray(data.content) ? data.content : []);
            setCurrentPage(data.number + 1);
            setTotalPages(data.totalPages);
        } catch (error) {
            console.error("Error fetching call logs:", error);
        }
        finally {
            setIsLoading(false);
        }
    };

    const fetchMechanics = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/mechanics`);
            const data = await response.json();
            setMechanics(data);
        } catch (error) {
            console.error("Error fetching mechanics:", error);
        }
    };


    const applyFilters = () => {
        let filtered = callLogs;
        if (filters.status) {
            filtered = filtered.filter(log => log.status === filters.status);
        }
        if (filters.priority) {
            filtered = filtered.filter(log => log.priority === Number(filters.priority));
        }
        setFilteredLogs(filtered);
    };

    const handleOpenModal = (callLog = null, isFollowUp = false) => {
        setEditingCallLog(callLog);
        setIsFollowUp(isFollowUp);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setEditingCallLog(null);
        setIsFollowUp(false);
        setIsModalOpen(false);
    };

    return (
        <div className="p-6">
            <h2 className="text-2xl font-bold mb-4 border-b-2 border-gray-800 pb-1">
                Trouble Call/Follow Ups/Shut Downs
            </h2>
            <FilterOptions filters={filters} setFilters={setFilters} handleOpenModal={() => handleOpenModal()} isDispatching={selectedLog}>



                <QuickDispatcher callNumber={selectedLog} mechanics={mechanics} 
                updateLog={(log) => {
                    const updatedLogs = callLogs.filter(l => l.callNumber !== log.callNumber);
                    setCallLogs(updatedLogs);
                    setSelectedLog(null);

                    setLatestDispatch(log);
                }}
                    isDisabled={selectedLog === null}
                />

            </FilterOptions>


            {filteredLogs.length === 0 && !isLoading ? (
                <div className="flex justify-center items-center mt-4">
                    <p className="text-gray-500">No call logs found.</p>
                </div>
            ) : (
                <>

                    <div className="flex justify-between items-center p-4 border-t border-gray-300 bg-white">
                        <PaginationControls
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={setCurrentPage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleRowsPerPageChange}
                        />
                    </div>
                    <CallLogsTable callLogs={filteredLogs} onEdit={handleOpenModal} onFollowUp={(log) => { handleOpenModal(log, true); }} selectedLog={selectedLog} setSelectedLog={setSelectedLog} isLoading={isLoading} />
                </>

            )}





            {isModalOpen && <CallLogForm isOpen={isModalOpen} onClose={handleCloseModal} fetchCallLogs={fetchCallLogs} mechanics={mechanics} editingCallLog={editingCallLog} isFollowUp={isFollowUp} />}
        </div>
    );
};

export default CallLogsPage;